import React from "react";
import EmployeeRating from "../components/EmployeeRating/EmployeeRating";

const EmployeeRatingScreen = () => {
  return <EmployeeRating />;
};

export default EmployeeRatingScreen;
